import React, {useCallback, useContext, useEffect, useRef, useState} from "react";
import UserContext from "../../common/UserContext";
import {GeneralContext, SearchProductContext} from "../FSARequestLicenseContext";
import {InputClearValue, TextBox} from "@progress/kendo-react-inputs";
import {Icon} from "@progress/kendo-react-common";
import {Button} from "@progress/kendo-react-buttons";
import {mainMessages, searchKey} from "../../../assets/text/MultilingualText";
import {useLocalization} from "@progress/kendo-react-intl";
import {CloseIcon} from "../../common/icons";
import {addDays, addYears} from "@progress/kendo-date-math";
import {uniqueId} from "lodash/util";
import {capitalizeSentence} from "../../common/utilities";
import {orderBy} from "@progress/kendo-data-query";
import axios from "axios";
import config from "../../../config";
import {useSupportContext} from "../../common/SupportContext";

export function SearchForm(props) {
    const {
        setDisplaySearchMessage
    } = props

    const {
        siteLanguageDefault,
        accessToken
    } = useContext(UserContext);

    const {
        setIsLoading,
        uniqueID,
        licenseStartDateKey,
        licenseEndDateKey,
        minDate,
        maxDate
    } = useContext(GeneralContext);

    const {
        setSearchedProducts,
    } = useContext(SearchProductContext);

    const { dispatch } = useSupportContext();

    const localization = useLocalization();

    const [searchValue, setSearchValue] = useState('')

    const onChange = useCallback(event => {
        setSearchValue(event.target.value);
    }, []);

    const handleClear = useCallback(() => {
        setSearchValue("");
    }, []);

    const count = useRef(0)

    const onSearch = () => {
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + accessToken,
        }
        let query = new URLSearchParams(window.location.search);
        const id = query.get('fsa_id');
        setIsLoading(true)

        const data = {
            "module": "FSA",
            "sub_module": "PRODUCT",
            "action": "SEARCH",
            "input_json": {
                "product_number": searchValue.trim(),
                "fsa_id": id
            }
        }

        dispatch({ type: 'UPDATE_TRANSACTION', payload: {search: searchValue.trim()}});

        axios.post(
            config.fsa_request_license.SEARCH,
            data,
            {headers: headers}
        )
            .then(res => {
                let data = res.data
                data = data.map(item => {
                    for (const license of item.license_type) {
                        license.text = ''
                        if (license.license_type !== null){
                            license.text = capitalizeSentence(license.license_type, true)
                        }
                    }

                    item.license_type = orderBy(item.license_type, [{
                        field: "text",
                        dir: "asc"
                    }])

                    if (item.license_type.length === 1) {
                        item.license_type[0].selected = true
                    } else {
                        item.license_type.unshift({
                            type: "Select",
                            selected: true,
                            base_price: 0,
                            text: "Select"
                        })
                    }

                    item[uniqueID] = count.current
                    count.current = count.current + 1

                    item['status'] = 'SEARCHED'
                    item['quantity'] = null
                    item[licenseStartDateKey] = minDate
                    item['start_date_valid'] = true
                    item[licenseEndDateKey] = maxDate
                    item['end_date_valid'] = true
                    item['exceedError'] = false
                    return item
                })
                setSearchedProducts(data)
                setDisplaySearchMessage(true)
            })
            .catch(err => {
                console.log("ERROR: Failed to SEARCH", err);
            })
            .finally(() => {
                setIsLoading(false);
            })
    }

    useEffect(() => {
        if(minDate !== null) {
            onSearch()
        }
    }, [minDate])// eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '0.5rem'
        }}>
            <div>
                <TextBox
                    value={searchValue}
                    onChange={onChange}
                    placeholder="Search"
                    suffix={
                        () =>
                            <>
                                {searchValue !== "" &&
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}>
                                        <CloseIcon
                                            onClick={handleClear}
                                            style={{
                                                cursor: 'pointer',
                                            }}
                                        />
                                    </div>

                                }
                            </>
                    }
                    style={{
                        width: '25rem',
                        height: '1.875rem',
                    }}
                />
            </div>

            <Button
                themeColor={"primary"}
                fillMode={"solid"}
                type={"button"}

                onClick={onSearch}
            >
                {localization.toLanguageString(searchKey, mainMessages[siteLanguageDefault][searchKey])}
            </Button>
        </div>
    )
}